export function addHttpToUrl(url, ssl) {
  if (!url) return "";

  if (!String(url).startsWith("http")) {
    return `http${ssl ? "s" : ""}://${url}`;
  }
  return url;
}
